module.exports = __webpack_public_path__ + "static/media/date-03.896d01e3.svg";